import { useFormik } from 'formik'
import InputText from 'global/InputText/InputText'
import SimpleButton from 'global/SimpleButton/SimpleButton'
import { useNavigate } from 'react-router-dom'

import { getAPI } from 'services/CRUDServices'

function PosPaymentInquiry({ orderId }) {
  const navigate = useNavigate()
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      RRN: '',
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true)
        await getAPI(
          `/consignment-api/hubPayments/saman-kish/inquiryPose/${orderId}/${values.RRN}`
        )
        navigate('/order-management')
      } catch {
      } finally {
        setSubmitting(false)
      }
    },
  })
  const { handleSubmit, values, handleChange, isSubmitting } = formik
  return (
    <form onSubmit={handleSubmit}>
      <div className='flex  gap-2 w-full  items-center mt-6'>
        <InputText
          label='مرجع پرداخت'
          name='RRN'
          handleChange={handleChange}
          values={values.RRN}
          //   error={
          //     (touched.goodsId && errors.goodsId) ||
          //     (goodsIdStatus === 'invalid' ? 'کد نامعتبر است' : '')
          //   }
          wrapperClassName='w-full'
          hiddenError
        />{' '}
        <SimpleButton
          text='استعلام'
          loading={isSubmitting}
          type='submit'
          className=' border border-tomato bg-white '
          loadingColor='tomato'
        />
      </div>
    </form>
  )
}

export default PosPaymentInquiry
